"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _OldBookings = _interopRequireDefault(require("../screens/OldBookings"));
var _appleLink = _interopRequireDefault(require("../../mutations/appleLink"));
var _context = require("../../../../services/log/context");
var _events = require("../../consts/events");
var _context2 = require("../../../../services/auth/context");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LinkBookingsScreen = ({
  onChangeScreen
}) => {
  const {
    log
  } = (0, _context.useLog)();
  const [isLoading, setLoading] = React.useState(false);
  const {
    onCloseModal,
    onGetUserInfoAndLogin
  } = (0, _context2.useAuth)();
  const {
    appleIdToken,
    appleUnconfirmedAuthToken
  } = (0, _context2.useAppleAuth)();
  function onContinueClick() {
    setLoading(true);
    if (appleIdToken != null && appleUnconfirmedAuthToken != null) {
      (0, _appleLink.default)({
        idToken: appleIdToken,
        token: appleUnconfirmedAuthToken
      }).then(res => {
        if ("success" in res) {
          return onGetUserInfoAndLogin({
            token: appleUnconfirmedAuthToken
          }).then(() => {
            onCloseModal();
          });
        }
        return Promise.resolve();
      }).catch(err => {
        log(_events.APPLE_LINK_FAILED, {
          error: String(err),
          operation: "appleLink"
        });
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }
  function onAddEmailClick() {
    onChangeScreen("linkBookings");
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OldBookings.default, {
    onContinueClick: onContinueClick,
    isLoading: isLoading,
    onAddEmailClick: onAddEmailClick
  });
};
var _default = LinkBookingsScreen;
exports.default = _default;